import { render } from "./EdiClaimPreviewOffcanvas.vue?vue&type=template&id=aca0af4e&scoped=true"
import script from "./EdiClaimPreviewOffcanvas.vue?vue&type=script&lang=js"
export * from "./EdiClaimPreviewOffcanvas.vue?vue&type=script&lang=js"

import "./EdiClaimPreviewOffcanvas.vue?vue&type=style&index=0&id=aca0af4e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aca0af4e"]])

export default __exports__